import { DeleteOutlined, EllipsisOutlined, StopOutlined, CheckOutlined } from "@ant-design/icons";
import { Dropdown } from "antd";

const ActionsDropdown = ({ remove, toggleStatus, isActive }) => {
  const items = [
    {
      key: "1",
      label: "Delete",
      icon: <DeleteOutlined />,
      onClick: () => remove(),
    },
    ...(toggleStatus
      ? [
          {
            key: "toggle",
            label: isActive ? "Deactivate" : "Activate",
            icon: isActive ? <StopOutlined /> : <CheckOutlined />,
            onClick: () => toggleStatus(),
          },
        ]
      : []),
  ];

  return (
    <Dropdown
      menu={{
        items,
        onClick: (e) => {
          e.domEvent.stopPropagation();
        },
      }}
      trigger={["click"]}
      styles={{ root: { width: 120 } }}
    >
      <EllipsisOutlined
        style={{ cursor: "pointer", width: 30 }}
        onClick={(e) => {
          e.stopPropagation();
        }}
      />
    </Dropdown>
  );
};

export default ActionsDropdown;
